import React, { useContext } from 'react';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
import Sticky from '../../../Sticky';
import MobileSubmissionDetailsHeader from '../../../SubmissionDetails/MobileSubmissionDetailsHeader';
import SiteHeader from '../../../SiteHeader';
import { useDuperbrowseViewType } from '../../../Duperbrowse/DuperbrowseViewContext';
var DeviationPageHeader = function (_a) {
    var environment = _a.environment;
    var isMobile = useContext(MobileContext);
    var isInDuperbrowse = useDuperbrowseViewType().isInDuperbrowse;
    if (!isMobile) {
        return React.createElement(SiteHeader, { environment: environment });
    }
    if (isInDuperbrowse) {
        return (React.createElement(Sticky, { marginTop: -1 }, function (isStuck) { return (React.createElement(MobileSubmissionDetailsHeader, { isSticky: true, isStuck: isStuck })); }));
    }
    return (React.createElement(React.Fragment, null,
        React.createElement(SiteHeader, { environment: environment }),
        React.createElement(MobileSubmissionDetailsHeader, { isSticky: false })));
};
DeviationPageHeader.displayName = 'DeviationPageHeader';
export default DeviationPageHeader;
//# sourceMappingURL=DeviationPageHeader.js.map